<script setup>
import {ref} from "vue";
import {Dialog, DialogOverlay, DialogPanel, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {Icon} from "@iconify/vue";

const isOpen = ref(false);
const emit = defineEmits(['closeModal']);

const props = defineProps({
  order: Object
})

function closeModal() {
  emit('closeModal');
}

function openDrawer() {
  isOpen.value = true;
}

function closeDrawer() {
  isOpen.value = false;
}

const formatText = (text) => {
  return text?.replace(/\n/g, '<br>') || ''
}
</script>

<template>
  <!-- Button to open drawer -->
  <button
      @click="openDrawer"
      class="text-white rounded-lg shadow"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         class="lucide lucide-clipboard-clock-icon lucide-clipboard-clock">
      <path d="M16 14v2.2l1.6 1"/>
      <path d="M16 4h2a2 2 0 0 1 2 2v.832"/>
      <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2"/>
      <circle cx="16" cy="16" r="6"/>
      <rect x="8" y="2" width="8" height="4" rx="1"/>
    </svg>
  </button>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" @close="closeDrawer" class="relative z-[999]">
      <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-[black]/60"/>
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="fixed inset-0 flex justify-end">
          <TransitionChild
              as="template"
              enter="transform transition ease-in-out duration-300"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leave-from="translate-x-0"
              leave-to="translate-x-full"
          >
            <DialogPanel
                class="w-80 bg-slate-700 shadow-xl text-white h-full overflow-auto custom-scrollbar-2 rounded-l-xl pr-2">
              <div class="p-2 flex flex-col gap-10 rounded-lg overflow-hidden text-sm">
                <div class="flex flex-col gap-1 h-max">
                  <p>ID: {{ order.id }}</p>
                  <p>UUID: {{ order.uuid }}</p>
                  <p>Store: {{ order.store }}</p>
                  <p>Game: {{ order.game }}</p>
                  <p>Server: {{ order.server }}</p>
                  <!--<p>Account: {{ accountTitle }}</p>-->
                  <p>Sell ID: {{ order.g2gSellID }}</p>
                </div>
                <p class="break-all" v-html="formatText(order?.logs)"></p>
<!--                <p class="break-all">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo, necessitatibus.</p>-->
              </div>

            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
